import React from 'react';
import { Grid } from '@material-ui/core';
import { Input } from 'components/shared/input';
import ReactPlayer from 'react-player';

interface AddEmbedVideoProps {
 embededVideoUrl: string;
 setEmbededVideoUrl(e: string): void;
}

export const AddEmbedVideo = ({ embededVideoUrl, setEmbededVideoUrl }: AddEmbedVideoProps) => {
 return (
  <Grid container spacing={2}>
   <Grid item xs={12}>
    {embededVideoUrl && <ReactPlayer url={embededVideoUrl} controls width='100%' />}
   </Grid>
   <Grid item xs={12}>
    <Input label='Video URL' onChange={(e: any) => setEmbededVideoUrl(e.target.value)} value={embededVideoUrl} fullWidth />
   </Grid>
  </Grid>
 );
};
